import React from 'react'

function UserNotifications() {
  return (
    <div>
      
    </div>
  )
}

export default UserNotifications
